import Breadcrumbs from "/components/common/breadcrumbs";
import styles from "./index.module.scss";
import Button from "../../../common/button";

export default function Detail({ brand }) {
  return (
    <div className="container">
      <Breadcrumbs />
      <h1>{brand.name}</h1>
      <div className={styles.Brand}>
        <div
          className="text"
          dangerouslySetInnerHTML={{ __html: brand.text }}
        />
        <div className={styles.Image}>
          <img src={brand.pictureSrc} />
        </div>
      </div>
      <Button
        label={"Все товары бренда"}
        onClick={() => {
          window.location.href = `/catalog/farkopy/filter/proizvoditel-${brand.filterCodeAlt}/`;
        }}
      />
      <br />
    </div>
  );
}
